import type { SVGProps } from "react";

export const SpinnerSvg = ({
  strokeWidth,
  ...rest
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <mask id="mask0_363_316" maskUnits="userSpaceOnUse" x="0" y="0">
      <path
        d="M32.0002 64C25.6712 64 19.4844 62.1232 14.222 58.607C8.95963 55.0908 4.8581 50.0931 2.4361 44.2459C0.0140953 38.3986 -0.619614 31.9645 0.615116 25.7571C1.84984 19.5497 4.89755 13.8479 9.37283 9.37258C13.8481 4.8973 19.55 1.8496 25.7574 0.614871C31.9647 -0.619856 38.3989 0.0138508 44.2461 2.43586C50.0933 4.85786 55.0911 8.95938 58.6073 14.2218C62.1235 19.4841 64.0002 25.671 64.0002 32H32.0002V64Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_363_316)">
      <path
        d="M32.0003 62.9985C27.9293 62.9985 23.8982 62.1966 20.1371 60.6387C16.376 59.0808 12.9586 56.7974 10.08 53.9188C7.20135 51.0401 4.9179 47.6227 3.36001 43.8616C1.80211 40.1005 1.00027 36.0694 1.00027 31.9984C1.00027 27.9275 1.80211 23.8964 3.36001 20.1353C4.91791 16.3742 7.20135 12.9568 10.08 10.0781C12.9586 7.19952 16.376 4.91608 20.1371 3.35818C23.8982 1.80029 27.9293 0.998451 32.0003 0.998451C36.0713 0.998452 40.1024 1.80029 43.8635 3.35819C47.6246 4.91608 51.042 7.19953 53.9206 10.0781C56.7992 12.9568 59.0826 16.3742 60.6405 20.1353C62.1984 23.8964 63.0003 27.9275 63.0003 31.9985C63.0003 36.0694 62.1984 40.1005 60.6405 43.8616C59.0826 47.6227 56.7992 51.0401 53.9206 53.9188C51.042 56.7974 47.6245 59.0808 43.8635 60.6387C40.1024 62.1966 36.0712 62.9985 32.0003 62.9985L32.0003 62.9985Z"
        strokeWidth={strokeWidth}
      />
    </g>
  </svg>
);
